import Typography from '@mui/material/Typography';
import React, { FC } from 'react';

import { useTakeControlMutation } from '@api/connectInstance';
import { useGetUsersMinFilteredQuery } from '@api/user';
import { DialogConfirmation } from '@uiKit/DialogConfirmation';
import { toast } from 'sonner';

import { setTakeControlDialog } from '@redux/slices/app';
import { useDispatch, useSelector } from '@redux/store';

const TakeControl: FC = () => {
  const { open, instanceId, controllingUserId } = useSelector((state) => state.app.takeControlDialog);
  const dispatch = useDispatch();

  const { data: connectedUser } = useGetUsersMinFilteredQuery(
    { Ids: [controllingUserId || ''] },
    { skip: !controllingUserId },
  );

  const connectedUserName = connectedUser?.items?.[0]?.displayName || 'Another user';

  const [takeControl, { isLoading }] = useTakeControlMutation();

  const handleClose = () => {
    if (isLoading) return;
    dispatch(setTakeControlDialog({ open: false, instanceId, controllingUserId }));
  };

  const handleAccept = async () => {
    if (!instanceId || !controllingUserId) return;
    try {
      await takeControl({ rdConnectInstanceId: instanceId });
      toast.success('Control taken successfully');
    } catch {
      toast.error('Something went wrong');
    } finally {
      handleClose();
    }
  };

  return (
    <DialogConfirmation
      open={open}
      handleClose={handleClose}
      title="Take control of Received Connect?"
      content={
        <Typography color="text.secondary">
          <Typography component="span" fontWeight="600">
            {connectedUserName}
          </Typography>{' '}
          is currently connected to Received Connect. If you take control, this user will be disconnected until they
          choose to take control again.
        </Typography>
      }
      acceptButtonTitle="Take Control"
      cancelButtonTitle="Cancel"
      acceptButtonHandleClick={handleAccept}
      cancelButtonHandleClick={handleClose}
      loading={isLoading}
      maxWidth="xs"
    />
  );
};

export default TakeControl;
